import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {LoaderClass} from "./LoaderClass"
import {getAuthHeader, getPathBack, setErrorWindow} from "../functions"
import {ModalWin} from "./ModalWin"
import {useNavigate} from "react-router-dom"

export const UpdateLanguages = () => {
    const {request, loading} = useHttp()
    const auth = useContext(AuthContext)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const navigate = useNavigate()

    const fetch = useCallback(async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            // Обновляем базу языков из кода на сервере
            const data = await request(
                `${host}/api/language/load`,
                'POST',
                {
                    en: 'en',
                    fr: 'fr',
                    ru: 'ru',
                    he: 'he',
                    ge: 'ge',
                    ar: 'ar'
                },
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status !== 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code, '', '', `replaceTo ${getPathBack()}`))
            } else {
                navigate(getPathBack(), {replace: true})
                // window.location.replace(getPathBack())
            }

        } catch (e) {
            console.error(e.message)
        }
    }, [request, auth, navigate])

    useEffect(() => {
        fetch().then()
    }, [fetch])

    if (loading) {
        return <LoaderClass />
    }

    if (!allowed) {
        return (<><ModalWin data={dataModal}/></>)
    } else {
        return (<></>)
    }
}